var googleMapsReady = false;
var searchReady = false;
var geocoder = null;
var map;
var mapInfoWindow;
var markersToShow;
let allowAutoFetch = false; // init to false
var debug = false;

// spawn worker to do some of the work off-thread
let locWorker = new Worker("/js/locations-worker.min.js");

locWorker.onmessage = function (msg) {
    if (!msg.isTrusted) {
        console.log("Main thread received message from untrusted source.");
        console.log(msg);
        return;
    }
    if (debug) {
        console.log("message from locWorker:");
        console.log(msg.data);
    }

    switch (msg.data.operation) {
        case "locParsed":
            window.locationsObject = msg.data.locations;
            if ($("#view-map").is(":visible")) {
                setupMap();
            }
            break;
        case "locPageHtml":
            if (msg.data.clearPrevious) {
                clearLocationsList();
            }
            appendLocationsList(msg.data.pageHtml);

            var loadMoreBtn = document.getElementById("load-more");
            if (loadMoreBtn != null) {
                // update Load More button
                if (msg.data.hasMore) {
                    loadMoreBtn.style.display = "flex";
                    loadMoreBtn.dataset.nextPage = parseInt(loadMoreBtn.dataset.nextPage) + 1;
                } else {
                    loadMoreBtn.style.display = "none";
                    loadMoreBtn.dataset.nextPage = -1;
                }
            }
            break;

        default:
            appendLocationsList(null);
            console.log(
                "Main thread received unknown operation from locations worker: " +
                msg.data.operation
            );
            console.log(msg.data);
    }
};

function clearLocationsList(html) {
    $("#locations-list").html("");
    $("#locations-mobile-list").html("");
}
function appendLocationsList(html) {
    if (html) {
        $("#locations-list").append(html);
        $("#locations-mobile-list").append(html);
    }

    setTimeout(() => {
        allowAutoFetch = true;
    }, 100); //delay allow fetch until after content append scroll event to prevent trigger loop when at bottom of page
}

// parse json taking a surprising amount of time, so doing it off-thread
locWorker.postMessage({
    operation: "init",
    locStr: window.locationsJsonString,
    pageType: window.pageType,
    phone: document.querySelector("#top .phone-holder").textContent.trim(),
    contactUrl:
        document.querySelector("title").textContent.indexOf("Ugly") == -1
            ? "/contact/"
            : "/contact-us/",
});

if (/complete|interactive|loaded/.test(document.readyState)) {
    // DOM is already ready
    pageSetup();
} else {
    document.addEventListener("DOMContentLoaded", pageSetup);
}

function pageSetup() {
    if ($("#view-map").is(":visible")) {
        // load map script if on tablet or larger
        loadMapScript();
    } else {
        // prepare to load script if window is expanded to larger breakpoint
        $(window).on("changed.zf.mediaquery", function (event, newSize, oldSize) {
            if (newSize == "large" || newSize == "xlarge") {
                loadMapScript();
                $(window).off("changed.zf.mediaquery");
            }
        });
    }

    navigator.geolocation.getCurrentPosition(
        function (position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };

            // sort markets by distance from geolocated position
            if (debug)
                console.log(
                    "sorting locations by distance from " +
                    position.coords.latitude +
                    ", " +
                    position.coords.longitude
                );

            locWorker.postMessage({ operation: "sortLocations", centerOn: pos });
        },
        function (error) {
            // geolocation error or denied
            console.log("Browser geolocation:", error);
        }
    );

    $("#view-map").on("click", function () {
        var $map = $("#locations-map");
        if (!$map.hasClass("initialized")) setupMap();

        if ($map.hasClass("open")) {
            $map.removeClass("open");
            $(this).text("View Map");
            $('.zip-container').removeClass('map-zip-container');
        } else {
            $map.addClass("open");
            $(this).text("Hide Map");
            $('.zip-container').addClass('map-zip-container');
        }
    });

    $('#zip-form input').one('focus', function () {
        loadMapScript(); // need the geolocator for the location search to work
        setupLocationSearch();
    });


    // load more button
    var loadMoreBtn = document.getElementById("load-more");
    if (pageType == "locations") {
        loadMoreBtn.dataset.nextPage = 1;
        loadMoreBtn.addEventListener("click", function () {
            var nextpage = parseInt(this.dataset.nextPage);
            var lat = loadMoreBtn.dataset.lat;
            var lng = loadMoreBtn.dataset.lng;

            if (typeof lat != 'undefined') {
                // ask server to sort locations based on counties
                $.get(`/market/?page=${nextpage}&lat=${lat}&lng=${lng}`, function (resp) {
                    let listHtml = '';
                    resp.pageOfMarkets.forEach(function (market) {
                        listHtml += getMarketBlockHtml(market);
                    });

                    appendLocationsList(listHtml);

                    // update Load More button
                    if (resp.hasMore) {
                        loadMoreBtn.dataset.nextPage = nextpage + 1;
                    } else {
                        loadMoreBtn.style.display = "none";
                        loadMoreBtn.dataset.nextPage = -1;
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    console.error("AJAX request failed:", textStatus, errorThrown);
                    appendLocationsList(null);
                });
            }
            else {
                // TODO: if we go full AJAX instead of location worker, 
                // we'll want to get rid of this branch and always use the first one
                locWorker.postMessage({ operation: "getLocPageHtml", pageNum: nextpage });
            }
        });
    } else {
        if (loadMoreBtn != null) loadMoreBtn.style.display = "none";
    }
}


window.initMap = function () {
    googleMapsReady = true;
    setupMap();
};

function loadMapScript() {
    if (typeof google != 'undefined' && typeof google.maps != 'undefined') {
        // google maps already loaded
        initMap();
    }
    else {
        var script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${window.wbuh.mapKey}&libraries=places,marker&loading=async&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
    }
}

function setupMap() {
    var mapEl = document.getElementById("locations-map");
    // already set up; we're done
    if (mapEl.classList.contains("initialized")) return;

    // not ready to set up map; this will get called again when ready
    if (!googleMapsReady || typeof window.locationsObject == "undefined") return;

    if (pageType == "locations") {
        mapInfoWindow = new google.maps.InfoWindow();
        if (debug) console.log("initMap");

        map = new google.maps.Map(mapEl, {
            center: { lat: 38.20365531807148, lng: -97.734375 },
            //zoom: defaultZoomLevel,
            zoom: 5,
            scrollwheel: false,
            mapTypeControl: false,
            mapId: "WBUH_LOCATIONS"
        });
        //locWorker.postMessage({ operation: 'googleMapsReady', map: map });

        if (debug)
            console.log("adding " + locationsObject.length + " markers to map");

        // add markers to map; save them in an array for further operations
        markersToShow = setMarkers(map);

        // if we have a location from the browser, start there
        if (navigator.geolocation) {
            if (debug) console.log("getting location from brower");

            navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                centerAndZoom(pos, map, markersToShow);
            });
        }

        mapEl.classList.add("initialized");
        setupLocationSearch();
    }
}

function setMarkers(map) {
    var markersToShow = [];

    for (var i = 0; i < locationsObject.length; i++) {
        var loc = locationsObject[i];

        var latLng = new google.maps.LatLng(loc["lat"], loc["lng"]);

        // Create a marker element
        const markerElement = document.createElement('div');
        markerElement.innerHTML = `<img src="${mapIcon}" alt="${loc["name"]}">`;

        var marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: latLng,
            content: markerElement,
            title: loc["name"],
        });

        // Store additional data in the marker object
        marker.url = loc["link"];

        marker.addListener("click", showInfoWindow);

        markersToShow.push(marker);
    }

    return markersToShow;
}

function showInfoWindow() {
    mapInfoWindow.setContent(
        "<a href='" + this["url"] + "'>" + this["title"] + " Details</a>"
    );
    mapInfoWindow.open(map, this);
}

function centerAndZoom(pos, map, markersToShow) {
    //$('#activeLat').val(pos.lat);
    //$('#activeLng').val(pos.lng);

    // the below process isn't perfect, but most of the time it will ensure that at least minNumMarkersToShow locations
    // are visible on the map, while keeping the input location centered

    // add the closest minNumMarkersToShow markers to a bounds object
    var minNumMarkersToShow = Math.min(minNumMarkersToShow, markersToShow.length);
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < minNumMarkersToShow; i++) {
        var loc = locationsObject[i];

        var markerPos;
        $.each(markersToShow, function () {
            markerPos = this.getPosition();
            if (
                markerPos.lat().toFixed(3) == loc.lat.toFixed(3) &&
                markerPos.lng().toFixed(3) == loc.lng.toFixed(3)
            ) {
                // toFixed allows for some approximation
                bounds.extend(markerPos);
                return false;
            }
        });
    }

    // make sure our center is in the bounds
    bounds.extend(pos);

    // after this, all points will be on map
    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
        map.setCenter(pos);

        // treating defaultZoomLevel as the maximum zoom
        var defaultZoomLevel = 6;
        if (map.getZoom() > defaultZoomLevel) map.setZoom(defaultZoomLevel);
    });
}

function setupLocationSearch() {
    if (searchReady)
        return;

    // ZIP code search
    var zipForm = document.getElementById("zip-form");
    var zipInput = document.getElementById("zip-code");

    zipForm.addEventListener("submit", function (e) {
        e.preventDefault();

        if (geocoder == null)
            geocoder = new google.maps.Geocoder();

        var geoQuery = {
            address: zipInput.value,
            componentRestrictions: {
                country: 'US'
            }
        };

        geocoder.geocode(geoQuery, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (debug)
                    console.log("got location from geolocated form submission");

                // if user entered a state that we have a page for, redirect them to the state page
                if (results[0].types.includes('administrative_area_level_1')) { // google thinks the result is a state
                    let redirecting = false;
                    let stateName = results[0].address_components[0].long_name;
                    let ourStates = $('footer .market-states a');
                    ourStates.each(function () {
                        if ($(this).text() == stateName) {
                            location.href = $(this).attr('href');
                            redirecting = true;
                            return false;
                        }
                    });
                    if (redirecting)
                        return;
                }

                var pos = {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng(),
                };

                if (debug)
                    console.log("sorting locations by distance from " + pos.lat + ", " + pos.long);

                // JS version working on center point of market
                //locWorker.postMessage({ operation: "sortLocations", centerOn: pos });


                // ask server to sort locations based on counties
                $.get(`/market/?page=1&lat=${pos.lat}&lng=${pos.lng}`, function (resp) {

                    var midListP = '';
                    if ($('#main-clone').length == 0) {
                        var $widgetArea = $('#main');
                        if (Foundation.mediaQuery.MediaQuery.atLeast('large'))
                            $('#locations-list-wrapper').closest('.content').after($widgetArea.clone().attr('id', 'main-clone'));
                        else
                            midListP = '<div id="main-clone">' + $widgetArea.html() + '</div>';
                    }

                    let listHtml = '';
                    resp.pageOfMarkets.forEach(function (market, index) {
                        listHtml += getMarketBlockHtml(market);
                        if (index == 2)
                            listHtml += midListP;
                    });

                    clearLocationsList();
                    appendLocationsList(listHtml);

                    // check this
                    let loadMoreBtn = document.getElementById("load-more");
                    if (loadMoreBtn != null) {
                        // update Load More button
                        if (resp.hasMore) {
                            loadMoreBtn.style.display = "flex";
                            loadMoreBtn.dataset.lat = pos.lat;
                            loadMoreBtn.dataset.lng = pos.lng;
                            loadMoreBtn.dataset.nextPage = 2;
                        } else {
                            loadMoreBtn.style.display = "none";
                            loadMoreBtn.dataset.nextPage = -1;
                        }
                    }


                    $('.locations-page').addClass('searched');
                    // add 'Showing results for' heading
                    var $resultsHeading = $('#results-heading');
                    var $resultsErrHeading = $('#results-error-heading');
                    if ($resultsHeading.length == 0) {
                        $resultsHeading = $('<h2 id="results-heading" class="content"></h2>').insertAfter($('.zip-container'));
                        $resultsErrHeading = $('<p id="results-error-heading" class="content text-center hide"></p>').insertAfter($resultsHeading);
                    }
                    $resultsErrHeading.addClass('hide').removeClass('text-danger');
                    $resultsHeading.removeClass('text-danger');

                    $resultsHeading.text('Showing results for ' + results[0].formatted_address.replace(', USA', '') + ':');
                    if (!isPartialLocationMatch(results[0])) {
                        // Google knows exactly what search meant
                    }
                    else if (isPartialLocationMatch(results[0]) && results[0].formatted_address != "United States") {
                        // Google made a partial match to search
                        $resultsHeading.addClass('after-search');
                        $resultsErrHeading.text("We couldn’t find " + zipInput.value + '.')
                            .removeClass('hide');
                    }
                    else if (isPartialLocationMatch(results[0]) && results[0].formatted_address == "United States") {
                        // Google couldn't match at all, so returns "United States"
                        $resultsHeading.text("We couldn’t find results for " + zipInput.value + '.')
                            .removeClass('after-search').addClass('text-danger');;
                        var phoneNo = document.querySelector("#top .phone-holder").textContent.trim();
                        $resultsErrHeading.html(`Please adjust your search or call <a href='tel:1-${phoneNo}' class='phone'>${phoneNo}</a> to find nearest location.`)
                            .removeClass('hide').addClass('text-danger');
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    console.error("AJAX request failed:", textStatus, errorThrown);
                    appendLocationsList(null);
                });

                // if map is shown center and zoom on searched position
                centerAndZoom(pos, map, markersToShow);
            } else {
                console.log("Geocode was not successful for the following reason: " + status);
            }
        });


        // load more button
        var loadMoreBtn = document.getElementById("load-more");
        loadMoreBtn.dataset.nextPage = 2;
        loadMoreBtn.style.display = "flex";
    });

    searchReady = true;
}

const mobileContainer = document.getElementById("locations-mobile-list");
const loadMoreBtn = document.getElementById("load-more");
if (mobileContainer && loadMoreBtn) {
    window.addEventListener('scroll', function () {
        const containerRect = mobileContainer.getBoundingClientRect();
        if (!containerRect.height > 0) return; //exit since mobile container is not visible
        if (!allowAutoFetch) return; //exit since already pending fetch
        if (parseInt(loadMoreBtn.dataset.nextPage) < 0) return; //exit since no more to load

        const containerBottom = containerRect.bottom;
        const windowHeight = window.innerHeight;

        if (containerBottom > 0 && containerBottom <= windowHeight + 100) { //px buffer
            // bottom of container is within px buffer of the viewport bottom
            allowAutoFetch = false; // prevent multiple calls while pending
            loadMoreBtn.click();
        }
    });
}

function fillZipFromPos(pos) {
    if (geocoder == null) geocoder = new google.maps.Geocoder();

    geocoder.geocode({ latLng: pos }, function (results, status) {
        var displayZip = "";

        if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
                // find the postal_code address component
                var addrComp = results[0].address_components;
                for (var i = 0; i < addrComp.length; i++) {
                    if (addrComp[i].types.includes("postal_code"))
                        displayZip = addrComp[i].short_name;
                }
            }
        }

        var zipForm = document.getElementById("zip-form");
        var zipInput = document.getElementById("zip-code");
        zipInput.value = displayZip;
        zipInput.classList.remove("geolocating");
        zipInput.parentNode.classList.remove("geolocating");
    });
}

function getMarketBlockHtml(market) {
    var titleHtml;
    var name = market.name;
    var nameMobile = market.nameMobile;

    // if main locations page (not state page), and state code not already included
    // attach normalized state code
    if (window.pageType == 'locations') {
        var stateCodes = market.stateCodes;
        if (name.indexOf(stateCodes[0]) == -1)
            name += ', ' + stateCodes.join('/');
        if (nameMobile.indexOf(stateCodes[0]) == -1)
            nameMobile += ', ' + stateCodes.join('/');
    }

    if (window.pageType == 'state') {
        name = market.nameBare;
        nameMobile = market.nameMobile;
    }

    if (nameMobile == name)
        titleHtml = '<h4 class="title">' + name + '</h4>';
    else
        titleHtml = '<h4 class="title hide-for-xlarge">' + nameMobile + '</h4><h4 class="title show-for-xlarge">' + name + '</h4>';

    var phoneNumber = document.querySelector("#top .phone-holder").textContent.trim();

    var contactUrl = document.querySelector("title").textContent.indexOf("Ugly") == -1
        ? "/contact/"
        : "/contact-us/";

    var pictureInnerHtml = '';

    // put image variants (if any) on page as <source> elements inside the <picture>
    var variants = market.photo.variants;
    if (variants.hasOwnProperty("MarketImageWebP"))
        pictureInnerHtml += '<source type="image/webp" srcset="' + variants.MarketImageWebP + '">';
    if (variants.hasOwnProperty("MarketImage")) {
        var urlSplits = market.photo.url.split('.');
        var mimeType = getImageMimeType(urlSplits[urlSplits.length - 1]); // get mime type from extension of the uploaded image
        pictureInnerHtml += '<source type="' + mimeType + '" srcset="' + variants.MarketImage + '">';
    }

    // there will always be a fallback image
    pictureInnerHtml += '<img alt="' + market.photo.altText + '" src="' + market.photo.url + '">';
    pictureInnerHtml += '<img loading="lazy" alt="' + market.photo.altText + '" src="' + market.photo.url + '">';


    return `
<div id="location-${market.id}" data-id="${market.id}" class="location-item small-12 large-6 xlarge-4 columns" data-loc-id="${market.id}">
    <a href="${market.link}" class="image-holder valign-wrapper">
        <picture>${pictureInnerHtml}</picture>
        ${titleHtml}
        <div class="overlay"></div>
    </a>
    <div class="text-wrapper">
        <a href="tel:1-${phoneNumber}" class="phone">${phoneNumber}&nbsp;</a>
        <div class="desc">${market.desc}</div>
        <div class="links">
            <a href="${market.link}">View Location</a> <span class="sep">|</span> <a href="${contactUrl}">Contact Us</a>
        </div>
    </div>

    <div class="text-wrapper wrapper-b">
        <div class="icons-container">
            <div class="text-center trio-icon-width">
                <a href="tel:1-${phoneNumber}" class="circle-links">
                    <div class="circle-phone"></div>
                    <div>Call Now</div>
                </a>
            </div>
            <div class="text-center trio-icon-width">
                <a href="${market.link}" class="circle-links">
                    <div class="circle-pin"></div>
                    <div>View Location</div>
                </a>
            </div>
            <div class="text-center trio-icon-width">
                <a href="${contactUrl}" class="circle-links">
                    <div class="circle-check"></div>
                    <div>Get Started</div>
                </a>
            </div>
            <div class="desc-b text-center">${market.desc} </div>

        </div>
    </div>

</div>
`;
}

function getImageMimeType(extension) {
    switch (extension.toLowerCase()) {
        case 'bmp':
            return 'image/bmp';
        case 'gif':
            return 'image/gif';
        case 'jpeg':
        case 'jpg':
            return 'image/jpeg';
        case 'png':
            return 'image/png';
        case 'svg':
            return 'image/svg+xml';
        case 'tif':
        case 'tiff':
            return 'image/tiff';
        case 'webp':
            return 'image/webp';
        default:
            return null;
    }
}

function isPartialLocationMatch(result) {
    return result.partial_match != null && result.partial_match != undefined && result.partial_match == true;
}
